export class UploadPhotoModel {
    title: string;
    fileName: string;
    fileContentBase64: string;
}